import React, { useState } from 'react'
import './ResetPassword.css'
import { Link, useNavigate } from 'react-router-dom'
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import apiServiceHandler from "../../service/apiService"
import Logo from '../../assets/image.png'

const ResetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await apiServiceHandler("POST", "api/auth/forgot", { email });
      if (response.auth) {
        toastr.success("Successfully sent OTP to your email")
        navigate("/verify-otp", { state: { email, secret: response.secret, resetPassword: true } });
      } else {
        toastr.error(response.message || "Failed to Reset Password. Please try again.")
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      console.error(error.response);
    }
  }
  return (
    <main className="auth">
      <div className="auth-layout">
        <div className="auth-view">
          <div className="auth-view__container">
            <div className="auth-logo">
              <img src={Logo} />
            </div>
            <div className="reset-view">
              <div className="reset-heading">RESET PASSWORD</div>
              <form className='reset-form' onSubmit={handleResetPassword}>
                <div className="reset-view__field">
                  <div className="reset-view__field-input" name="email">
                    <div className="text-input_input-wrapper">
                      <input
                        type="text"
                        className="auth-text-input__input"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                </div>
                <button className="reset-btn">
                  <span className='reset-button__label'>SEND RESET INSTRUCTIONS</span>
                </button>
              </form>
              <div className="reset-view__footer" >
                <Link to="/login" className="reset-link">
                  Return to login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default ResetPassword